import type { App } from 'vue'
import {
  ElLoading,
  ElMessage,
  ElMessageBox,
  ElCard,
  ElTable
} from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// 需要手动注册的插件（自动导入无法处理的）
const plugins = [ElLoading]

// 新增全局组件属性配置
/** global table column align */
ElTable.TableColumn.props.align = {
  type: String,
  default: 'center'
};

/** global ElCard shadow */
ElCard.props.shadow = {
  type: String,
  default: 'never'
};

/**
 * 设置UI框架
 * @param app 应用实例
 */
export const setupUI = (app: App) => {
  // 仅保留必须手动注册的部分
  plugins.forEach(plugin => {
    app.use(plugin)
  })

  // 全局配置
  app.config.globalProperties.$ELEMENT = {
    size: 'default',
    zIndex: 2000,
    locale: zhCn
  }

  // 挂载全局方法（自动导入无法处理的）
  app.config.globalProperties.$message = ElMessage
  app.config.globalProperties.$confirm = ElMessageBox.confirm
} 